/* eslint-disable */
import React, { Component, createRef } from 'react';
import ReactGA from 'react-ga';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import { isMobile  } from 'react-device-detect';
import SSOFT_HEADER_912 from '../../sections/SSoft_Header_912/SSoft_Header';
import SSOFTNEW_HERO_1325 from '../../sections/SSoftNew_Hero_1325/SSoftNew_Hero';
import SSOFTNEW_OUR_SERVICES_1326 from '../../sections/SSoftNew_Our_Services_1326/SSoftNew_Our_Services';
import SSOFTNEW_LINE_SERVICES_1327 from '../../sections/SSoftNew_Line_Services_1327/SSoftNew_Line_Services';
import SSOFTNEW_OUR_CLIENT_1328 from '../../sections/SSoftNew_Our_Client_1328/SSoftNew_Our_Client';
import SSOFT_INDUSTRIES_1329 from '../../sections/SSoft_Industries_1329/SSoft_Industries';
import SSOFT_FAQ_1330 from '../../sections/SSoft_FAQ_1330/SSoft_FAQ';
import SSOFT_HOME_ABOUT_1331 from '../../sections/SSoft_Home_About_1331/SSoft_Home_About';
import SSOFT_FOOTER_913 from '../../sections/SSoft_Footer_913/SSoft_Footer';

function withParams(Component) {
    return props => <Component {...props} params={useParams()} />;
}

class project1 extends Component {
   constructor(props) {
       super(props);
       this.state = {
           currentPage: null,
           currentSection: null,
           override: true,
           section: [
               { id: 1, slug: localStorage.getItem('language') === "English"? 'hero' : 'hero'},
               { id: 2, slug: localStorage.getItem('language') === "English"? 'service' : 'service'},
               { id: 3, slug: localStorage.getItem('language') === "English"? 'solutions' : 'solutions'},
               { id: 4, slug: localStorage.getItem('language') === "English"? 'clients' : 'clients'},
               { id: 5, slug: localStorage.getItem('language') === "English"? 'industries' : 'industries'},
               { id: 6, slug: localStorage.getItem('language') === "English"? 'faq' : 'faq'},
               { id: 7, slug: localStorage.getItem('language') === "English"? 'about' : 'about'},
           ],
       };
       this.scrollToSection = this.scrollToSection.bind(this);
       this.scrollAction = this.scrollAction.bind(this);
        this.isStateChanging = false
   }
   componentDidMount() {
       this.scrollToSection();
       ReactGA.initialize('')
       ReactGA.pageview(window.location.pathname + window.location.search);
   }
   componentWillUnmount(){
   }
   section1 = createRef()
   section2 = createRef()
   section3 = createRef()
   section4 = createRef()
   section5 = createRef()
   section6 = createRef()
   section7 = createRef()
   scrollToSection() {
       let currentLocation = window.location.href
       const hasSectionAnchor = currentLocation.includes('/#')
       if (hasSectionAnchor) {
           let anchorSectionId = `${currentLocation.substring(currentLocation.indexOf('#') + 1)}`
           setTimeout(() => { this.scrollAction(anchorSectionId) }, 1000)
       }
   }
   scrollAction(anchorSectionId) {
       const uri_dec = decodeURIComponent(anchorSectionId)
       const key = this.state.section.filter(x => x.slug == uri_dec).map(obj => `section${obj.id}`)
       const getY = (element) => element.getBoundingClientRect().top + window.pageYOffset - 140;
       if (key) {
          if (key[0] === 'section1') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section1.current), behavior: 'smooth' })}, 1000)
          } else if (key[0] === 'section2') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section2.current), behavior: 'smooth' })}, 1000)
          } else if (key[0] === 'section3') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section3.current), behavior: 'smooth' })}, 1000)
          } else if (key[0] === 'section4') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section4.current), behavior: 'smooth' })}, 1000)
          } else if (key[0] === 'section5') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section5.current), behavior: 'smooth' })}, 1000)
          } else if (key[0] === 'section6') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section6.current), behavior: 'smooth' })}, 1000)
          } else if (key[0] === 'section7') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section7.current), behavior: 'smooth' })}, 1000)
            }
       }
   }
   render() {
       const getHelmetTitle = () => {
           var title;
           switch (localStorage.getItem('language')) {
               case 'English':
                   title = <title> Home | Supersoft</title>;
                   break;
               case 'Indonesian':
                   title = <title> Home | Supersoft</title>;
                   break;
               default:
                   title = <title> Home | Supersoft</title>;
                   break;
           }
           return title;
       };
       const getHelmetDescription = () => {
           var description;
           switch (localStorage.getItem('language')) {
               case 'English':
                   description = <meta name='description' content='Get things  done with the  right partners - PT Supersoft' />;
                   break;
               case 'Indonesian':
                   description = <meta name='description' content='Selesaikan semuanya  dengan mitra  yang tepat - PT Supersoft' />;
                   break;
               default:
                   description = <meta name='description' content='Get things  done with the  right partners - PT Supersoft' />;
                   break;
           }
           return description;
       };
       const getHelmetKeywords = () => {
           var keywords;
           switch (localStorage.getItem('language')) {
               case 'English':
                   keywords = <meta name='keywords' content='' />;
                   break;
               case 'Indonesian':
                   keywords = <meta name='keywords' content='' />;
                   break;
               default:
                   keywords = <meta name='keywords' content='' />;
                   break;
           }
           return keywords;
       };
         let helmet = getHelmetTitle();
         let description = getHelmetDescription();
         let keywords = getHelmetKeywords();
       return (
           <>
               <Helmet>
                   {helmet}
                   {description}
                   {keywords}
               </Helmet>
            <div ref={this.section1}>
                <SSOFTNEW_HERO_1325 />
            </div>
            <div ref={this.section2}>
                <SSOFTNEW_OUR_SERVICES_1326 />
            </div>
            <div ref={this.section3}>
                <SSOFTNEW_LINE_SERVICES_1327 />
            </div>
            <div ref={this.section4}>
                <SSOFTNEW_OUR_CLIENT_1328 />
            </div>
            <div ref={this.section5}>
                <SSOFT_INDUSTRIES_1329 />
            </div>
            <div ref={this.section6}>
                <SSOFT_FAQ_1330 />
            </div>
            <div ref={this.section7}>
                <SSOFT_HOME_ABOUT_1331 />
            </div>
           </>
       );
   }
}
export default withParams(project1);